import { Capacitor } from "@capacitor/core";
import { Directory, Filesystem } from "@capacitor/filesystem";
import { AlertProps } from "@mui/lab";
import { Base64 } from "js-base64";
import { FileUpload, getSingleFileUploadViaFileEntryApi } from "model";
import { AppDispatch } from "model/rootReducer";

export const downloadFileHelper = async (
  fileEntryId: string,
  dispatch: AppDispatch,
  notify: (message: string, severity?: AlertProps["severity"]) => void
) => {
  try {
    const fileUpload = (
      await dispatch(getSingleFileUploadViaFileEntryApi({ guid: fileEntryId }))
    ).payload as FileUpload;

    const fileName = fileUpload.fileName;

    if (
      Capacitor.getPlatform() === "ios" ||
      Capacitor.getPlatform() === "android"
    ) {
      await Filesystem.writeFile({
        path: fileUpload.fileName,
        data: fileUpload.file,
        directory: Directory.Documents,
        recursive: true,
      });
    } else {
      const data = Base64.toUint8Array(fileUpload.file);
      const blob = new Blob([data]);
      const a = document.createElement("a");
      document.body.appendChild(a);
      a.setAttribute("style", "display: none");
      const url = window.URL.createObjectURL(blob);
      a.href = url;
      a.download = fileUpload.fileName;
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    }

    notify(`Saved file ${fileName}`);
  } catch (error) {
    console.error("Error downloading file:", error);
    notify("Error downloading file", "error");
  }
};
